import { isSubAccountEmbedSession } from 'v2/shared/utils/embed-session'
import { errorToast } from 'v2/utils/toasts'
import { FlowNodeTypes } from '../types'

// Nodes whose pickers read org-wide routes hodor refuses to sub-account embed sessions. They are
// off the palette there; an agent that already has one still renders it, read-only, with the reason.
const LOCKED_NODE_REASONS: Partial<Record<FlowNodeTypes, string>> = {
  [FlowNodeTypes.queue_and_route]:
    'Queues and teams are not available for this account, so this node is read-only.',
  [FlowNodeTypes.business_hour]:
    'Business hours are not available for this account, so this node is read-only.',
  [FlowNodeTypes.ai_skills]:
    'AI models and voices are not available for this account, so this node is read-only.',
}

export const subAccountLockedNodeReason = (nodeType?: string): string | undefined =>
  isSubAccountEmbedSession() ? LOCKED_NODE_REASONS[nodeType as FlowNodeTypes] : undefined

// Paste and import are palette adds by another route, so they refuse locked nodes too. True (after
// telling the user) when refused; callers ask before writing anything, so the agent stays intact.
export const refuseSubAccountLockedNodes = (
  nodes: { type?: string }[],
  action: 'paste' | 'import',
): boolean => {
  if (!nodes.some((node) => !!subAccountLockedNodeReason(node.type))) return false
  errorToast({
    title: action === 'import' ? 'Cannot import this agent' : 'Cannot paste these nodes',
    description:
      'Assign to human, Business hour and Skills nodes are not available for this account.',
  })
  return true
}
